module.exports = __webpack_public_path__ + "static/media/Heart.17f16389.svg";